module.exports = __webpack_public_path__ + "img/infog.6ed593a4.png";